<template>
  <transition name="modal">

    <!-- New Modal -->
    <div class="modal-overlay" style="opacity: 1.09; display: block;">
      <div class="modal-wrapper showSweetAlert visible" data-custom-class="" data-has-cancel-button="true" data-has-confirm-button="true" data-allow-outside-click="false" data-has-done-function="true" data-animation="pop" data-timer="null" style="display: block; margin-top: -191px;">
        <spinner v-if="isLoading"></spinner>
        <errors v-if="isVisibleErrorsModal"></errors>
        <div class="modal-close col-sm-12 text-right">
          <button class="modal-button" @click="closeModal()"><span class="icon-close"></span></button>
        </div>
        <header class="modal-header">
          <h2 class="modal-title ">Create an account</h2>
        </header>

        <div class="modal-body mt-lg">
            <slot name="body">
              <p class="modal-paragraph">
                  Choose the type of account to get started
              </p>

              <fieldset class="row pt-lg">
                <div class="col-md-6">
                  <div v-bind:class="accountType === 'joint' ? 'radio-item' : 'radio-item radio-item-unselected'">
                    <input id="ritema" name="accountType" type="radio" v-bind:value="'joint'"
                      v-model="accountType"/>
                    <label for="ritema">Joint</label>
                  </div>
                </div>

                <div class="col-md-6">
                  <div v-bind:class="accountType === 'institution' ? 'radio-item' : 'radio-item radio-item-unselected'">
                    <input id="ritemb" name="accountType" type="radio" v-bind:value="'institution'"
                      v-model="accountType"/>
                    <label for="ritemb">Institution</label>
                  </div>
                </div>

                <div class="col-md-6">
                  <div v-bind:class="accountType === 'trust' ? 'radio-item' : 'radio-item radio-item-unselected'">
                    <input id="ritemc" name="accountType" type="radio" v-bind:value="'trust'"
                      v-model="accountType"/>
                    <label for="ritemc">Trust</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div v-bind:class="accountType === 'utma-ugma' ? 'radio-item' : 'radio-item radio-item-unselected'">
                    <input id="ritemd" name="accountType" type="radio" v-bind:value="'utma-ugma'"
                      v-model="accountType"/>
                    <label for="ritemd">UTMA/UGMA</label>
                  </div>
                </div>
              </fieldset>
            </slot>
          </div>
          <div class="modal-buttons mt-lg">
            <slot name="body">
              <div class="row">
                <div class="col-md-12 text-right">
                  <button type="submit" class="btn btn-info btn-lg btn-outline" @click="closeModal()">Cancel</button>
                  <button type="submit" class="btn btn-info btn-lg btn-create" v-bind:disabled="!accountType" @click="submitAccountType()">Create account</button>
                </div>
              </div>
            </slot>
          </div>

      </div>
    </div>
    <!-- End of New Modal -->
  </transition>
</template>

<script>
  import {
    mapActions,
    mapMutations,
    mapState,
  } from 'vuex';
  import {
    HIDE_ACCOUNT_CREATION_MODAL,
  } from '@/store/mutation-types';

  export default {
    name: 'accountCreation',
    props: ['closeAction'],
    data() {
      return {
        accountType: '',
        isLoading: false,
      };
    },
    computed: {
      ...mapState('accountCreation', [
        'userId',
        'name',
      ]),
      ...mapState('errors', [
        'isVisibleErrorsModal',
      ]),
    },
    methods: {
      ...mapActions('user', [
        'storeAccountTypeInSessionStorage',
      ]),
      ...mapMutations('accountCreation', {
        hideAccountCreationModal: HIDE_ACCOUNT_CREATION_MODAL,
      }),
      submitAccountType() {
        this.isLoading = true;
        this.hideAccountCreationModal();
        let routeName = '';
        if (this.accountType === 'joint' || this.accountType === 'utma-ugma') {
          routeName = 'AccountCreationAdmin';
        } else if (this.accountType === 'institution' || this.accountType === 'trust') {
          routeName = 'AccountCreationOrganization';
        }
        this.storeAccountTypeInSessionStorage(this.accountType);
        this.isLoading = false;
        this.$router.push({
          name: routeName,
          params: {
            name: this.name,
            userId: this.userId,
            accountType: this.accountType,
          },
        });
      },
      closeModal() {
        this.hideAccountCreationModal();
        if (typeof this.closeAction === 'function') {
          this.closeAction();
        }
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.radio-item {
  display: inline-block;
  position: relative;
  padding: 0 6px;
  margin-bottom: 10px;
}
.radio-item input[type='radio'] {
  display: none;
}
.radio-item label {
  color: #666;
  font-weight: normal;
  cursor: pointer;
}
.radio-item label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 5px;
  left: 0px;
  margin: 0 20px 0 0;
  width: 20px;
  height: 20px;
  border-radius: 11px;
  background-color: transparent;
}
.radio-item-unselected label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 5px;
  left: 0px;
  margin: 0 20px 0 0;
  width: 20px;
  height: 20px;
  border-radius: 11px;
  background-color: transparent;
  border: 2px solid #d3d3d3;
}
.radio-item input[type=radio]:checked+label:after {
  border-radius: 11px;
  width: 10px;
  height: 10px;
  position: absolute;
  top: 10px;
  left: 11px;
  content: " ";
  display: block;
}
</style>



// WEBPACK FOOTER //
// AccountCreation.vue?1531852c